import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: "1 0 auto",
    height: "100vh",
    position: "relative", //needed for topBg
  },
  titleContainer: {
    flex: 1,
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
    marginRight: 15, //scrollbar
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
  },
  subheaderDivider: {
    height: 2,
  },
  subheaderTitle: {
    fontWeight: theme.typography.fontWeightHeavy,
    display: "inline-flex",
  },
  textRight: {
    textAlign: "right",
  },
  togoIcon: {
    fontSize: "2rem",
    position: "relative",
    top: 6,
  },
  button: {
    boxShadow: "none",
  },
  margin0: {
    margin: 0,
  },
  orderDate: {
    display: "flex",
    justifyContent: "flex-end",
  },
  margin1: {
    margin: theme.spacing(0.5),
  },
  topBorder: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  foodList: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  foodTitle: {
    marginLeft: 10,
  },
}));
